<template lang="pug">
  .shipping-step
    //- .panel.mb-8
    //-   .box
    //-     template
    //-       .shipping-fee
    //-         .preview
    //-           .icon
    //-             svg(
    //-               xmlns="http://www.w3.org/2000/svg"
    //-               fill="none"
    //-               viewBox="0 0 24 24"
    //-               stroke="currentColor"
    //-             )
    //-               //- Dollar
    //-               //- d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"

    //-               path(
    //-                 stroke-linecap="round"
    //-                 stroke-linejoin="round"
    //-                 stroke-width="1.3"
    //-                 d="M14.121 15.536c-1.171 1.952-3.07 1.952-4.242 0-1.172-1.953-1.172-5.119 0-7.072 1.171-1.952 3.07-1.952 4.242 0M8 10.5h4m-4 3h4m9-1.5a9 9 0 11-18 0 9 9 0 0118 0z"
    //-               )
    //-           .data
    //-             .field-preview
    //-               .label Versandkosten
    //-               //- TODO
    //-               .field-label {{ shippingFee | moneyFormat(currency) }}
    //-     .shipping-methods(v-if="methods.length <= 1")
    //-       hr.my-4
    //-       ShippingMethod(
    //-         v-for="(method, i) in methods" :key="method.id"
    //-         :data="method"
    //-         :active="method.id === shipping.id"
    //-         :show-divider="i + 1 < methods.length"
    //-         :show-label="true"
    //-       )
    //-         template(v-slot:icon)
    //-           svg(
    //-             xmlns="http://www.w3.org/2000/svg"
    //-             fill="none"
    //-             viewBox="0 0 24 24"
    //-             stroke="currentColor"
    //-           )
    //-             //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
    //-             path(
    //-               stroke-linecap="round"
    //-               stroke-linejoin="round"
    //-               stroke-width="1.3"
    //-               d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
    //-             )

    //- .shipping-methods(v-if="methods.length > 1")
    //-   h4.panel-heading Versandart
    .shipping-methods
      .panel.mb-8
        .box
          ShippingMethod(
            v-for="(method, i) in methods" :key="method.id"
            :data="method"
            :active="method.id === shipping.id"
            :show-divider="i + 1 < methods.length"
            @select="select"
          )
            template(v-if="methods.length === 1" v-slot:icon)
              svg(
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              )
                //- d="M12 8v13m0-13V6a2 2 0 112 2h-2zm0 0V5.5A2.5 2.5 0 109.5 8H12zm-7 4h14M5 12a2 2 0 110-4h14a2 2 0 110 4M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7"
                path(
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.3"
                  d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
                )

          //- hr.my-4
          //- // TODO: multiple addresses / add address
          //- AddressForm(type="shipping" label="Lieferadresse" :show-name="true")

    .shipping-addresses
      h4.panel-heading Lieferadresse
      .panel.mb-8
        .box
          Address(
            v-for="(address, i) in addresses" :key="address.id"
            :data="address"
            :active="address.id === shippingAddress.id"
            :show-divider="true"
            :show-label="false"
            @select="setShippingAddress"
          )
          AddressForm(
            label="Lieferadresse"
            type="shipping"
            :show-name="editName"
            :show-label="false"
            :show-checkbox="addresses.length >= 1"
            :active="showAddressForm"
            @select="setShippingAddress"
            @edit="editAddress = true"
          )
</template>

<script>
import uniqid from "uniqid";
import { mapGetters, mapMutations } from "vuex";
import { get, cloneDeep } from "@/helpers";

import ShippingMethod from "@/extensions/shop/components/CheckoutStepper/Steps/Partials/ShippingMethod";
import AddressForm from "@/extensions/shop/components/CheckoutStepper/Steps/Partials/AddressForm";
import Address from "@/extensions/shop/components/CheckoutStepper/Steps/Partials/Address";

export default {
  name: "ShippingStep",
  props: {
    // form: {
    //   type: Object,
    //   required: true
    // }
  },
  data: () => ({
    editName: true, // TODO: make editable by clicking on pencil icon
    editAddress: false
  }),
  components: {
    ShippingMethod,
    AddressForm,
    Address
  },
  computed: {
    addresses() {
      return this.addressOptions.shipping;
    },
    shippingAddress() {
      return this.checkout.form.account.shipping_address;
    },
    showAddressForm() {
      if (this.isAuthenticated && this.addresses.length) {
        return get(this.shippingAddress, "id", "").startsWith("new:");
      } else {
        return this.editAddress;
      }
    },
    currency() {
      return (
        get(this.customer, "customerGroup.currency.iso4217") ||
        get(this.defaultCustomerGroup, "customerGroup.currency.iso4217") ||
        "EUR"
      );
    },
    methods() {
      return this.shippingMethodOptions || [];
    },
    shipping: {
      get() {
        return this.checkout.form.shipping;
      },
      set(value) {
        this.setShipping(value);
      }
    },
    ...mapGetters({
      customer: "shop/customer",
      isAuthenticated: "auth/isAuthenticated",
      defaultCustomerGroup: "shop/defaultCustomerGroup",
      shippingMethodOptions: "shop/shippingMethodOptions",
      addressOptions: "shop/addressOptions",
      shippingFee: "shop/shippingFee",
      checkout: "shop/checkout"
    })
  },
  methods: {
    select(method) {
      this.shipping = method;
    },
    ...mapMutations({
      setShipping: "shop/setCheckoutFormShipping",
      setShippingAddress: "shop/setCheckoutFormShippingAddress"
    })
  },
  mounted() {
    if (!this.shipping.id && this.methods.length >= 1) {
      this.shipping = this.methods[0];
    }

    // fill address if guest or if not address options
    if (!this.shippingAddress.id) {
      const account = this.checkout.form.account;
      let address = cloneDeep(account.billing_address);
      address.id = uniqid("new:");

      // address.gender = account.gender;
      // address.first_name = account.first_name;
      // address.last_name = account.last_name;
      // address.phone = account.phone;
      // address.mobile = account.mobile;
      // address.email = account.email;

      this.setShippingAddress(address);
    }
  }
};
</script>

<style lang="sass" scoped></style>
